import { render } from "./MyTickets.vue?vue&type=template&id=722c20d2&scoped=true"
import script from "./MyTickets.vue?vue&type=script&lang=js"
export * from "./MyTickets.vue?vue&type=script&lang=js"

import "./MyTickets.vue?vue&type=style&index=0&id=722c20d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722c20d2"]])

export default __exports__